module.exports = __webpack_public_path__ + "static/media/mz.f1049422.svg";